"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const get_1 = __importDefault(require("lodash/get"));
const react_2 = require("react");
const ui_1 = require("react-science/ui");
const AssignmentsContext_1 = require("../../assignment/AssignmentsContext");
const filterForIDsWithAssignment_1 = require("../../assignment/utilities/filterForIDsWithAssignment");
const highlight_1 = require("../../highlight");
const AbsoluteColumn_1 = __importDefault(require("./TableColumns/AbsoluteColumn"));
const ActionsColumn_1 = __importDefault(require("./TableColumns/ActionsColumn"));
const CouplingColumn_1 = __importDefault(require("./TableColumns/CouplingColumn"));
const RangeAssignmentsColumn_1 = __importDefault(require("./TableColumns/RangeAssignmentsColumn"));
const RangeColumn_1 = __importDefault(require("./TableColumns/RangeColumn"));
const RelativeColumn_1 = __importDefault(require("./TableColumns/RelativeColumn"));
const SignalAssignmentsColumn_1 = __importDefault(require("./TableColumns/SignalAssignmentsColumn"));
const SignalDeltaColumn_1 = __importDefault(require("./TableColumns/SignalDeltaColumn"));
const SignalDeltaHzColumn_1 = __importDefault(require("./TableColumns/SignalDeltaHzColumn"));
const HighlightedRowStyle = (0, react_1.css) `
  background-color: #ff6f0057;
`;
const ConstantlyHighlightedRowStyle = (0, react_1.css) `
  background-color: #f5f5dc;
`;
function RangesTableRow({ rowData, onUnlink, onContextMenuSelect, contextMenu = [], preferences, info, }) {
    const assignmentData = (0, AssignmentsContext_1.useAssignmentData)();
    const assignmentRange = (0, AssignmentsContext_1.useAssignment)(rowData.id);
    const highlightRange = (0, highlight_1.useHighlight)([assignmentRange.id].concat(assignmentRange.assigned?.x || []).concat((0, filterForIDsWithAssignment_1.filterForIDsWithAssignment)(assignmentData, rowData.signals.map((_signal) => _signal.id))), { type: highlight_1.HighlightEventSource.RANGE });
    const highlightRangeAssignmentsColumn = (0, highlight_1.useHighlight)(assignmentRange.assigned?.x || [], { type: highlight_1.HighlightEventSource.RANGE });
    const assignmentSignal = (0, AssignmentsContext_1.useAssignment)(rowData.tableMetaInfo.id);
    const highlightSignal = (0, highlight_1.useHighlight)([assignmentSignal.id].concat(assignmentSignal.assigned?.x || []), { type: highlight_1.HighlightEventSource.SIGNAL });
    const highlightData = (0, highlight_1.useHighlightData)();
    const rowSpanTags = (0, react_2.useMemo)(() => {
        return {
            rowSpan: rowData.tableMetaInfo.rowSpan,
            style: (0, get_1.default)(rowData.tableMetaInfo, 'hide', false)
                ? { display: 'none' }
                : undefined,
        };
    }, [rowData.tableMetaInfo]);
    const unlinkHandler = (0, react_2.useCallback)((e, isOnRangeLevel) => {
        // stop propagation here to prevent enabling/disabling the assignment mode at the same time
        if (e) {
            e.stopPropagation();
        }
        if (isOnRangeLevel !== undefined) {
            if (isOnRangeLevel) {
                onUnlink(rowData);
                assignmentRange.removeAll('x');
            }
            else {
                onUnlink(rowData, (0, get_1.default)(rowData, 'tableMetaInfo.signalIndex', undefined));
                assignmentSignal.removeAll('x');
            }
        }
    }, [assignmentRange, assignmentSignal, onUnlink, rowData]);
    const linkHandler = (0, react_2.useCallback)((e, assignment) => {
        e.stopPropagation();
        assignment.setActive('x');
    }, []);
    const onHoverRange = (0, react_2.useMemo)(() => {
        return {
            onMouseEnter: () => {
                assignmentRange.show('x');
                highlightRange.show();
            },
            onMouseLeave: () => {
                assignmentRange.hide();
                highlightRange.hide();
            },
        };
    }, [assignmentRange, highlightRange]);
    const onHoverRangeAssignmentsColumn = (0, react_2.useMemo)(() => {
        return {
            onMouseEnter: () => {
                assignmentRange.show('x');
                highlightRangeAssignmentsColumn.show();
            },
            onMouseLeave: () => {
                assignmentRange.hide();
                highlightRangeAssignmentsColumn.hide();
            },
        };
    }, [assignmentRange, highlightRangeAssignmentsColumn]);
    const onHoverSignal = (0, react_2.useMemo)(() => {
        return {
            onMouseEnter: () => {
                assignmentSignal.show('x');
                highlightSignal.show();
            },
            onMouseLeave: () => {
                assignmentSignal.hide();
                highlightSignal.hide();
            },
        };
    }, [assignmentSignal, highlightSignal]);
    const trCss = (0, react_2.useMemo)(() => {
        return highlightRange.isActive || assignmentRange.isActive
            ? HighlightedRowStyle
            : (0, get_1.default)(rowData, 'tableMetaInfo.isConstantlyHighlighted', false)
                ? ConstantlyHighlightedRowStyle
                : null;
    }, [assignmentRange.isActive, highlightRange.isActive, rowData]);
    return ((0, jsx_runtime_1.jsxs)(ui_1.DropdownMenu, { trigger: "contextMenu", options: contextMenu, onSelect: (selected) => onContextMenuSelect?.(selected, rowData), as: "tr", css: trCss, children: [preferences.showSerialNumber && ((0, jsx_runtime_1.jsx)("td", { ...rowSpanTags, ...onHoverRange, children: rowData.tableMetaInfo.rowIndex + 1 })), preferences.from.show && ((0, jsx_runtime_1.jsx)(RangeColumn_1.default, { value: rowData.from, rowSpanTags: rowSpanTags, onHover: onHoverRange, format: preferences.from.format })), preferences.to.show && ((0, jsx_runtime_1.jsx)(RangeColumn_1.default, { value: rowData.to, rowSpanTags: rowSpanTags, onHover: onHoverRange, format: preferences.to.format })), preferences.deltaPPM.show && ((0, jsx_runtime_1.jsx)(SignalDeltaColumn_1.default, { row: rowData, rowSpanTags: rowSpanTags, onHover: onHoverSignal, format: preferences.deltaPPM.format })), preferences.deltaHz.show && ((0, jsx_runtime_1.jsx)(SignalDeltaHzColumn_1.default, { row: rowData, rowSpanTags: rowSpanTags, onHover: onHoverSignal, format: preferences.deltaHz.format, info: info })), preferences.relative.show && ((0, jsx_runtime_1.jsx)(RelativeColumn_1.default, { row: rowData, rowSpanTags: rowSpanTags, onHover: onHoverRange, format: preferences.relative.format })), preferences.absolute.show && ((0, jsx_runtime_1.jsx)(AbsoluteColumn_1.default, { row: rowData, rowSpanTags: rowSpanTags, onHover: onHoverRange, format: preferences.absolute.format })), preferences.showMultiplicity && ((0, jsx_runtime_1.jsx)("td", { ...onHoverSignal, children: (0, get_1.default)(rowData, 'tableMetaInfo.signal.multiplicity', '') })), preferences.coupling.show && ((0, jsx_runtime_1.jsx)(CouplingColumn_1.default, { row: rowData, onHover: onHoverSignal, format: preferences.coupling.format })), preferences.showAssignment && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(SignalAssignmentsColumn_1.default, { row: rowData, assignment: assignmentSignal, highlight: highlightSignal, onHover: onHoverSignal, onLink: linkHandler, onUnlink: unlinkHandler }), (0, jsx_runtime_1.jsx)(RangeAssignmentsColumn_1.default, { row: rowData, assignment: assignmentRange, highlight: highlightRangeAssignmentsColumn, onHover: onHoverRangeAssignmentsColumn, onLink: linkHandler, onUnlink: unlinkHandler, rowSpanTags: rowSpanTags, highlightData: highlightData })] })), (0, jsx_runtime_1.jsx)(ActionsColumn_1.default, { row: rowData, onHoverSignal: onHoverSignal, onHoverRange: onHoverRange, rowSpanTags: rowSpanTags, showKind: preferences.showKind, showDeleteAction: preferences.showDeleteAction, showEditAction: preferences.showEditAction, showZoomAction: preferences.showZoomAction })] }));
}
exports.default = RangesTableRow;
